import { render } from "./OrdersComponent.vue?vue&type=template&id=3527fef8"
import script from "./OrdersComponent.vue?vue&type=script&lang=js"
export * from "./OrdersComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__